import "./style.scss";
import * as React from "react";
import { Link, withRouter } from "react-router-dom";
import { utils } from "../../../common";

import Section from "../../../core/Section";
import Button from "../../../core/Button";
import Tabs, { TabPane } from "../../../core/Tabs";

import ViewReportsContainer from "../ViewReports";
import ViewReportFilesContainer from "../ViewReportFiles";

class ViewReport extends React.Component<any, any> {
  componentWillMount() {
    if (
      this.props.location.state &&
      this.props.location.state.merchant_selection
    ) {
      const merchant_id = utils.merchantIdFromProps(this.props);
      this.props.selectMerchant(merchant_id);
    }
  }

  render() {
    return (
      <Section className="view-reports">
        <Link
          className="new-report"
          to={`/merchants/${this.props.match.params.merchant_id}/reports/new`}
        >
          <Button type="primary">New Report</Button>
        </Link>

        <br />

        <Tabs defaultActiveKey="1">
          <TabPane tab="FILE EXPORT STATUS" key="1">
            <ViewReportFilesContainer />
          </TabPane>
          <TabPane tab="REPORT TEMPLATES" key="2">
            <ViewReportsContainer />
          </TabPane>
        </Tabs>
      </Section>
    );
  }
}

export default withRouter(ViewReport);



// WEBPACK FOOTER //
// ./client/modules/Report/components/ViewReport/component.tsx